import { useMutation } from "@tanstack/react-query";
import { apiPost, getApiUrl, type FetchResponse } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type AddChatChannelMemberRequest = {
  identityUserPublicIDs: ReadonlyArray<string>;
};

type MutationParams = {
  channelId: string;
  identityUserPublicIDs: ReadonlyArray<string>;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

const postChatChannelMembers = (
  request: AddChatChannelMemberRequest,
  channelId: string,
) =>
  apiPost<FetchResponse<void, 200>, AddChatChannelMemberRequest>(
    `${getApiUrl()}/api/Chat/channel/${channelId}/members`,
    request,
    undefined,
  );

export const useAddChatChannelMemberMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ channelId, identityUserPublicIDs }: MutationParams) =>
        postChatChannelMembers(
          { identityUserPublicIDs: [...identityUserPublicIDs] },
          channelId,
        ),
    ),
    onSuccess,
    onError,
  });
